import React, { useEffect, useState } from "react";
import { TrendingUp, TrendingDown, Wallet, Receipt } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import StatCard from "@/components/StatCard";
import { Skeleton } from "@/components/ui/skeleton";

const fmt = (n) => new Intl.NumberFormat("tr-TR").format(n);

export default function Reports() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/reports/summary").then((r) => setData(r.data)).catch(() => {}); }, []);

  if (!data) return <div className="space-y-4"><PageHeader title="Raporlar" subtitle="Gelir & gider analizi" /><div className="grid grid-cols-2 lg:grid-cols-4 gap-4">{[...Array(4)].map((_, i) => <Skeleton key={i} className="h-32 rounded-2xl bg-[#13131C]" />)}</div></div>;

  return (
    <div className="space-y-8" data-testid="admin-reports-page">
      <PageHeader title="Raporlar" subtitle="Gelir & gider analizi (gerçek veriler)" />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard testId="report-month-revenue" icon={Wallet} label="Bu Ay Gelir" value={`₺${fmt(data.month_revenue)}`} accent />
        <StatCard testId="report-month-expenses" icon={Receipt} label="Bu Ay Gider" value={`₺${fmt(data.month_expenses)}`} />
        <StatCard testId="report-net" icon={data.net >= 0 ? TrendingUp : TrendingDown} label="Net" value={`₺${fmt(data.net)}`} />
        <StatCard testId="report-total-revenue" icon={Wallet} label="Toplam Gelir" value={`₺${fmt(data.total_revenue)}`} sub={`${data.payment_count} ödeme`} />
      </div>
      <div className="rounded-2xl bg-[#13131C] border border-[#222230] p-5">
        <h4 className="font-display font-bold text-white text-lg mb-4">Ödeme Yöntemine Göre Gelir</h4>
        {data.by_method.length === 0 ? <p className="text-[#68687B] text-sm">Henüz ödeme yok.</p> : (
          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={data.by_method} margin={{ left: -8, right: 8 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#1E1E2A" vertical={false} />
              <XAxis dataKey="label" stroke="#68687B" fontSize={12} tickLine={false} axisLine={false} />
              <YAxis stroke="#68687B" fontSize={11} tickLine={false} axisLine={false} tickFormatter={(v) => `${v / 1000}k`} />
              <Tooltip cursor={{ fill: "#1B1B27" }} contentStyle={{ background: "#181824", border: "1px solid #2D2D3F", borderRadius: 12 }} formatter={(v) => `₺${fmt(v)}`} />
              <Bar dataKey="value" fill="#FF5500" radius={[6, 6, 0, 0]} barSize={48} />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
}
